// extracted by mini-css-extract-plugin
module.exports = {"actions":"RecentFolderRow-actions-3b5zR TableRowCell-cell-2fbg4"};